<template>
    <div class="main-head">
        <div class="logo">
            <img src="../assets/logo_pequeno.png" class="img-logo">
            <div class="titulo">
                <h1>RAT OnLine</h1>
            </div>
        </div>
        <figure class="profile">
            <figcaption>
                <h2>{{nomeUsuario}}</h2>
                <h3>{{dadosEmpresa.Razao_Social}}</h3>
                <button class="btn" @click="logout()">Logout <img src="./../assets/user-logout.png"></button>
            </figcaption>                    
            <img src="./../assets/profile.png" alt="" class="img-foto">

        </figure>
    </div>
</template>

<script>
import api from '../services/api.js';

export default {
  data: () => ({
      nomeUsuario: 'Usuario',
      nomeEmpresa: 'Empresa',
      codTecnico: 22,
      dadosTecnico:{},
      dadosEmpresa:{},      
  }),
  methods: {
    logout(){
        localStorage.removeItem('usuarioLogado');    
        localStorage.removeItem('codUsuarioLogado'); 
    
        this.$router.push('/');
        window.location.reload();        
    },       
      async pegarTecnico(){
            try {
                let dados = {codTecnico: this.codTecnico}
                const response = await api.post('tecnico',dados); // Aguarda a resposta da API
                console.log(response);

                let nomes = response.data.nome_tecnico.split(' '); 
                this.nomeUsuario = nomes.slice(0, 2).join(' ');


            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
      },        
      async pegarEmpresa(){
            try {
                const response = await api.get('empresa'); // Aguarda a resposta da API
                console.log(response);

                this.dadosEmpresa = response.data;

                       

            } catch (error) {
                console.log(error);
                alert('Error - listar empresa \n' + '-' + error.response?.data || error.message);
            }
      }    
    
  },
  mounted() {
      

    
  },  
  async created(){
      this.codTecnico =  localStorage.getItem('codUsuarioLogado');
      await this.pegarEmpresa();
      await this.pegarTecnico();
  }
}
</script>

<style>
@import '../css/components/main-head.css';
</style>